<template>
  <div class="tickets-container">
    <header>
      <div class="tickets-counter">
        <h4>
          Messenger
        </h4>
        <span>
          {{ unreadMessages }}
        </span>
      </div>
    </header>
    <div class="tickets-button-container">
      <b-button expanded rounded :loading="$store.state.websocket.loadingCreateTicket" @click="createTicket()">
        {{ $t('newMessenger.startConversation') }}
      </b-button>
    </div>
    <div v-if="$store.state.websocket.loadingTicketList" class="skeleton-tickets">
      <div v-for="index in 6" :key="index" class="skeleton-ticket">
        <div class="skeleton-flex-row" style="margin-bottom: 12px;">
          <div style="width: 24px;">
            <b-skeleton width="24px" height="24px" circle />
          </div>
          <b-skeleton width="50%" />
        </div>
        <div class="skeleton-flex-row">
          <b-skeleton />
        </div>
      </div>
    </div>
    <div v-else class="tickets-list" @scroll="checkScroll">
      <new-messenger-ticket
        v-for="(ticket, index) in tickets"
        :key="index"
        :ticket="ticket"
        @click.native="emitEnterConversation(ticket.id)"
      />
      <div v-if="$store.state.websocket.loadingTicketListMore" class="scroll-information">
        <b-loading active :is-full-page="false" />
      </div>
    </div>
  </div>
</template>

<script>
import NewMessengerTicket from './NewMessengerTicket'

export default {
  name: 'NewMessengerTickets',
  components: { NewMessengerTicket },
  props: {
    tickets: {
      type: Array,
      default: () => []
    },
    unreadMessages: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loadTickets: false
    }
  },
  methods: {
    createTicket () {
      this.$store.dispatch('websocket/createRoom', { type: 'store', id: 0 })
    },
    emitEnterConversation (id) {
      this.$emit('enterConversation', id)
    },
    setLoadTickets (status) {
      this.loadTickets = status
    },
    checkScroll ({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollHeight >= (clientHeight + 100) && !this.loadTickets) {
        if (scrollTop + clientHeight >= (scrollHeight - 100)) {
          this.loadTickets = true
          this.$emit('loadMoreTickets')
        }
      } else if ((scrollTop + clientHeight >= scrollHeight) && !this.loadTickets) {
        this.loadTickets = true
        this.$emit('loadMoreTickets')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$messenger-border-color: #E7E8E7;
$messanger-button-text-color: #909090;
$messanger-shadow-icon-button: #F8F8F8;
$messenger-selected-color: #E32F30;

.dropdown-tickets {
  :deep(.dropdown-tickets-icon) {
    width: 34px;
    height: 34px;
    border-radius: 50px;
    padding: 6px;
  }

  :deep(.dropdown-tickets-icon)>i {
    font-size: 16px !important;
    color: $messanger-button-text-color;
  }

  :deep(.dropdown-tickets-icon.back)>i {
    font-size: 12px !important;
  }
}

.dropdown-tickets-icon:hover {
  background-color: $messanger-shadow-icon-button;
  transition: background-color 0.5s ease-in-out;

}

.back {
  background-color: $messanger-shadow-icon-button;
  transition: background-color 0.5s ease-in-out;
}

.dropdwon-tickets-container-switch {
  display: flex;
  flex-direction: column;
  gap: 10px;

  :deep(.dropdown-tickets-switch) {
    font-size: 14px;
  }
}

:deep(.dropdown-tickets-checkbox) {
  font-size: 14px;
}

.dropdown-tickets-items {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  width: 220px;

  .dropdown-tickets-button-reset {
    border: none;
    color: $messanger-button-text-color;
  }

  .dropdown-tickets-button-apply {
    font-weight: 600;
  }

  .dropdown-tickets-items-title {
    font-weight: bold;
    margin-bottom: 10px;
  }

  @media (max-width: 1024px) {
    width: 100%;
  }
}

.dropdown-tickets-button {
  background-color: transparent;
  border: 0px;
}

.dropdown-tickets-flag {
  display: flex;
  flex-direction: row;
  justify-content: space-around;

  .dropdown-tickets-flag-circle {
    width: 28px;
    padding: 1px;
  }

  .selected {
    border: 2px solid $messenger-selected-color;
    border-radius: 50px;
  }
}

.tickets-container {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    height: 64px;
    padding: 0 16px;
    border-bottom: 1px solid $messenger-border-color;

    .tickets-counter {
      display: flex;
      align-items: center;
      gap: 6px;

      h4 {
        display: inline-block;
        font-weight: 600;

        @include touch {
          font-size: 20px;
        }
      }

      span {
        display: inline-flex;
        width: 22px;
        height: 22px;
        align-items: center;
        justify-content: center;
        background-color: $primary;
        border-radius: 50%;
        color: white;
        font-size: 13px;
        font-weight: 600;
      }
    }
  }

  .tickets-search-container {
    flex-shrink: 0;
    min-height: 0;
    padding: 16px;
    border-bottom: 1px solid $messenger-border-color;
    overflow: hidden;

    &:deep(input) {
      height: 40px;
      padding-left: 38px;
      // font-size: 14px;
    }

    &:deep(.icon) {
      width: 30px !important;
      left: 8px;

      i {
        font-size: 14px !important;
      }
    }
  }

  .tickets-button-container {
    flex-shrink: 0;
    min-height: 0;
    padding: 16px;
    border-bottom: 1px solid $messenger-border-color;
    overflow: hidden;
  }

  .tickets-list {
    position: relative;
    overflow: hidden auto;
    -webkit-overflow-scrolling: touch;

    & > :deep(.ticket) {
      border-bottom: 1px solid $messenger-border-color;
    }

    .scroll-information {
      position: sticky;
      left: calc(50% - 24px);
      right: 0;
      bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 48px;
      height: 48px;
      border-radius: 50%;
      overflow: hidden;
      background-color: white;
      z-index: 100;
      box-shadow: 0 2px 2px rgba($text_color, 0.2);
      :deep(.loading-icon):after {
        width: 2rem;
        height: 2em;
        top: calc(50% - 1em);
        left: calc(50% - 1em);
      }
    }
  }

  .skeleton-tickets {
    .skeleton-ticket {
      padding: 12px 16px;
      border-bottom: 1px solid $messenger-border-color;
      .skeleton-flex-row {
        display: flex;
        align-items: center;
        gap: 10px;
        .b-skeleton {
          margin: 0;
        }
      }
    }
  }
}
</style>
